import React from "react";

import { FieldProps } from "../../../types/FormTypes";
import Switch from "../Switch/Switch";
import Field from "../Field/Field";
import { useField } from "../Form/Form";
import styles from "./SwitchField.module.scss";

export interface SwitchFieldProps extends Omit<FieldProps<boolean>, "error"> {
  error?: boolean | string;
  /** Whether the label appears before or after the switch. Defaults to \"end\" (right). */
  placement?: "start" | "end";
}

const SwitchField = (props: SwitchFieldProps) => {
  const {
    name,
    label,
    helperText,
    error,
    disabled,
    fullWidth = false,
    placement: labelPlacement = "end",
    value: controlledValue,
    required,
    onChange,
    onValueChange,
    ...otherProps
  } = props;
  const field = useField<boolean>({ name, value: controlledValue, onChange, onValueChange, required });
  const value = typeof field.value === "boolean" ? field.value : false;
  const errorMessage = typeof error === "string" ? error : undefined;
  const hasError = Boolean(field.error || errorMessage || (typeof error === "boolean" ? error : false));

  return (
    <Field
      className={styles.switchContainer}
      name={name}
      fullWidth={fullWidth}
    >
      <div
        className={styles.switchRow}
        data-label-placement={labelPlacement}
      >
        <Field.Control>
          <Switch
            ref={field.ref as any}
            value={value}
            onValueChange={field.onValueChange}
            onBlur={field.onBlur}
            disabled={disabled}
            {...otherProps}
          />
        </Field.Control>
        <div className={styles.switchContent}>
          <Field.Label required={field.required} className={styles.label}>{label}</Field.Label>
          <Field.Message
            error={hasError}
            message={errorMessage ?? helperText}
          />
        </div>
      </div>
    </Field>
  );
};

export default SwitchField;
